
import React from 'react';
import CacaAoTesouro from './containers/CacaAoTesouroContainer';


const CacaAoTesouroApp = () => <CacaAoTesouro />;

export default CacaAoTesouroApp;
